import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
var _templateObject;
import { css } from '@emotion/react';
import { center, borderRadius } from '@atlaskit/media-ui';
import { themed } from '@atlaskit/theme/components';
import { N20, DN50, N50, DN100 } from '@atlaskit/theme/colors';
export var wrapperStyles = function wrapperStyles(_ref) {
  var dimensions = _ref.dimensions,
    theme = _ref.theme;
  return css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  ", "\n  background: ", ";\n  color: ", ";\n  ", "\n  max-height: 100%;\n  max-width: 100%;\n  width: ", ";\n  height: ", ";\n"])), center, themed({
    light: "var(--ds-background-neutral, ".concat(N20, ")"),
    dark: "var(--ds-background-neutral, ".concat(DN50, ")")
  })({
    theme: theme
  }), themed({
    light: "var(--ds-icon, ".concat(N50, ")"),
    dark: "var(--ds-icon, ".concat(DN100, ")")
  })({
    theme: theme
  }), borderRadius, dimensions.width, dimensions.height);
};